/* eslint-disable @typescript-eslint/no-unused-vars */
import { FeaturesFlags } from "helpers";
import { useEnvContext } from "contexts/EnvProvider";
import { useWebStoreContext } from "contexts";
import PageTopNavV2 from "components/PageTopNavV2";
import { PageContent } from "components/PageContent";
import NoSessionLayout from "components/NoSessionLayout";
import NoFriendsLayout from "./NoFriendsLayout";
import HeaderBanner from "./HeaderBanner";
import { useGetFriendsFriendShopQuery } from "redux/apis/friendShop";
import { useGoogleAnalyticsContext } from "contexts";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ButtonTab, Container } from "./styles";
import { useLinks } from "hooks";

const FriendCenter = () => {
	const navigate = useNavigate();
	const { friend_center } = useLinks();
	const { isFeatureFlagEnabled } = useEnvContext();
	const { authToken } = useWebStoreContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const {
		data: friendsData,
		isSuccess,
		isLoading
	} = useGetFriendsFriendShopQuery(undefined, {
		refetchOnMountOrArgChange: true,
		refetchOnFocus: true,
		refetchOnReconnect: true,
		skip: !authToken?.value
	});

	const hasNoFriends = isSuccess && (friendsData?.users?.length ?? 0) === 0;
	const friendShopAndReferralEnabled =
		isFeatureFlagEnabled(FeaturesFlags.FRIEND_SHOP) &&
		isFeatureFlagEnabled(FeaturesFlags.FRIEND_REFERRAL);

	useEffect(() => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "friend_center_launch",
			event_type: "friend_center",
			action: "launched_success",
			source: "friend_center"
		});
	}, []);

	const handleWebShopClick = () => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "web_shop_tab_click",
			event_type: "friend_referral_ui",
			action: "tab_click",
			source: "web_friend_referral"
		});
		navigate(`${friend_center.path}/shop/gifts`);
	};

	const handleWebInviteClick = () => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "web_invite_tab_click",
			event_type: "friend_referral_ui",
			action: "tab_click",
			source: "web_friend_referral"
		});
		navigate(`${friend_center.path}/invite/progress`);
	};

	return (
		<>
			{!authToken?.value ? (
				<NoSessionLayout
					loginBoxTitle="Welcome!"
					loginBoxSubtitle="Sign in to enter to Friend Center"
					loginBoxSource="login_to_continue_dialog#friend-center"
				/>
			) : hasNoFriends ? (
				<NoFriendsLayout />
			) : (
				<div style={{ position: "relative" }}>
					<HeaderBanner />
					<PageTopNavV2
						sectionMenuData={[]}
						isLandingPage
						//hasSectionBanner={true}
					/>

					<PageContent
						source="friend_center_page"
						sxContainer={{
							backgroundColor: "transparent",
							marginTop: "20px"
						}}
					>
						{!isLoading ? (
							<>
								{friendShopAndReferralEnabled && (
									<Container>
										<ButtonTab
											className={
												window.location.pathname.includes("shop")
													? "active"
													: ""
											}
											onClick={handleWebShopClick}
										>
											Shop
										</ButtonTab>
										<ButtonTab
											className={
												window.location.pathname.includes("invite")
													? "active"
													: ""
											}
											onClick={handleWebInviteClick}
										>
											Web Invite
										</ButtonTab>
									</Container>
								)}
								<Outlet />
							</>
						) : null}
					</PageContent>
				</div>
			)}
		</>
	);
};

export default FriendCenter;
